import SubmissionFirstProjectModule from './submission-firstproject.module'

export default SubmissionFirstProjectModule
